/**
 * Created by ivan on 11.04.18.
 */

const FriendRequestsToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.FRIEND_REQUESTS);
    this.lastNotProceedId = cleverapps.dataLoader.load(DataLoader.TYPES.LAST_VIEWED_FRIEND_REQUEST, { raw: true });

    levels.friendRequests.on("load", () => {
        this.mark();
        cleverapps.toolbar.updateItems();

        if (!levels.friendRequests.existNotProcessed()) {
            this.unmark();
            cleverapps.toolbar.updateItems(true);
        }
    });

    this.enable();
    this.mark();
};

FriendRequestsToolbarItem.prototype = Object.create(ToolbarItem.prototype);
FriendRequestsToolbarItem.prototype.constructor = FriendRequestsToolbarItem;

FriendRequestsToolbarItem.prototype.mark = function () {
    const friends = cleverapps.friends.listFriends();
    if (friends.length === 0) {
        return;
    }

    const lastNotProcessedId = levels.friendRequests.lastNotProcessedId();
    if (lastNotProcessedId === false || lastNotProcessedId === this.lastNotProceedId) {
        return;
    }

    ToolbarItem.prototype.mark.apply(this);
};

FriendRequestsToolbarItem.prototype.isVisible = function () {
    return levels.friendRequests.existNotProcessed();
};

FriendRequestsToolbarItem.prototype.onClick = function () {
    this.lastNotProceedId = levels.friendRequests.lastNotProcessedId();
    cleverapps.dataLoader.save(DataLoader.TYPES.LAST_VIEWED_FRIEND_REQUEST, this.lastNotProceedId, { raw: true });
    this.unmark();

    cleverapps.focusManager.display({
        focus: "FriendRequestsWindow",
        control: ["MenuBarGoldItem", "MenuBarLivesItem"],
        action: function (f) {
            const player = new ActionPlayer([
                Friends.loadFriends,

                (f) => {
                    new FriendRequestsWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            ]);
            player.onComplete(f);
            player.play();
        }
    });
};